import { useMemo } from 'react';
import { useGetProfile } from './useProfile.ts';

export const useLayoutType = () => {
  const { data: profile } = useGetProfile();

  const layoutType = useMemo(() => {
    if (!profile?.data) return 'loading';
    
    const currentRole = profile.data.current_role || 'member';
    const isGroupAdmin = profile.data.is_group_admin === true;
    
    if (currentRole === 'member') {
      return 'member';
    } else if (currentRole === 'admin' && isGroupAdmin) {
      return 'admin';
    } else {
      return 'member'; // fallback to member layout
    }
  }, [profile]);

  return layoutType;
}; 